export default __webpack_public_path__ + "static/media/taking-a-good-look.1b6f02dc.jpg";